import type { DeepPartial } from '@luna/utils-ts';

import type { SepaDirectDebit } from './SepaDirectDebit';

export const HU: DeepPartial<SepaDirectDebit> = {
    creditorSelectSearchMinLength: 3,
    isAssistantEnabled: true,
    mandateIdMatchString: /^[a-zA-Z0-9éáúüűóöőíÉÁÚÜŰÓÖŐÍ/\\\-_!?:., ]*$/.toString(),
};
